export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/d50cc34e778c6c20c755dccf4a153599.svg";